const state = () => ({
    error: null,
    isOpenCertificateModal: false,
    isOpenCalendar: false,
    discountQueue: false,
    requiredFields: {
        sumChange: "sum-change",
        bonusCount: "bonus-count",
        userEmail: "user-email",
        deferOrderTime: "defer-order-time",
        street: "street",
        house: "house"
    },
    requiredFieldsError: {},
    preOrderSchedule: {}
});

// getters
const getters = {
    getIsOpenCertificateModal: (state) => {
        return state.isOpenCertificateModal;
    },
    getDiscountQueue: (state) => {
        return state.discountQueue;
    },
    getRequiredFields: (state) => {
        return state.requiredFields;
    },
    getRequiredFieldsState: (state) => {
        return state.requiredFieldsError;
    },
    isOpenCalendar: (state) => {
        return state.isOpenCalendar;
    },
    getPreOrderSchedule: (state) => {
        return state.preOrderSchedule;
    },
    getError: (state) => {
        return state.error;
    }
}

// actions
const actions = {

}

// mutations
const mutations = {
    setIsOpenCertificateModal(state, modalState) {
        state.isOpenCertificateModal = modalState;
    },
    setDiscountQueue: (state, queue) => {
        state.discountQueue = queue;
    },
    addRequiredFieldError: (state, fieldState) => {
        Object.assign(state.requiredFieldsError, fieldState);
    },
    clearRequiredFieldError: (state) => {
        state.requiredFieldsError = {};
    },
    setOpenCalendar: (state, value) => {
        state.isOpenCalendar = value;
    },
    setPreOrderSchedule: (state, value) => {
        state.preOrderSchedule = value;
    },
    setError: (state, error) => {
        state.error = error;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
